import classNames from "classnames";
import type { FC } from "react";
import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";

export const ToggleHeaderCell: FC<ITableHeaderCellProps> = (props) => {
    const { fields, field, onColumnReformat, className } = props;
    return (
        <div className={`toggle-header-cell ${className}`}>
            {fields.map((item, index) => {
                return (
                    <button
                        key={index}
                        className={classNames(
                            "widget-toggle-button widget-toggle-button-table",
                            item.field === field ? "widget-toggle-button--active" : "",
                        )}
                        onClick={() => {
                            onColumnReformat(props, item);
                        }}
                    >
                        <i className={`toggle-header-cell-icon sw-icon-${item.symbol}`} />
                    </button>
                );
            })}
        </div>
    );
};
ToggleHeaderCell.displayName = "ToggleHeaderCell";
